import * as React from 'react';
import {DashboardAtrasoPorSistemaEtapa, DashboardAtrasoPorSistemaEtapaFields} from "../types/dashboard";
import {DefaultizedPieValueType, pieArcLabelClasses, PieChart} from "@mui/x-charts";
import CardActions from "../../sistema/components/CardActions";
import {mangoFusionPalette} from "@mui/x-charts/colorPalettes";

interface MensajesPorEtapaChartChartProps {
  data: DashboardAtrasoPorSistemaEtapa[]
}

export default function MensajesPorEtapaChart({data}: MensajesPorEtapaChartChartProps) {
  const getArcLabel = (params: DefaultizedPieValueType) => {
    const total = data?.map(x => x[DashboardAtrasoPorSistemaEtapaFields.CantMensajes]).reduce((a, b) => a + b, 0)
    const percent = params.value / total

    return `${(percent * 100).toFixed(0)}%`
  };

  return (
    <CardActions title={'Mensajes por Etapa'}
                 colapsable
    >

      <PieChart
        margin={{right: 150}}
        dataset={data}
        colors={mangoFusionPalette}
        series={[
          {
            outerRadius: 120,
            innerRadius: 50,
            paddingAngle: 1,
            data: data?.map(x => ({
              id: x.id,
              value: x[DashboardAtrasoPorSistemaEtapaFields.CantMensajes],
              label: x[DashboardAtrasoPorSistemaEtapaFields.Etapa],

              //  color: COLOR_MAP[x[DashboardMensajesPorEtapaEstadoFields.EtapaEstado]],
            })),
            arcLabel: getArcLabel,
            arcLabelMinAngle: 10,


            // arcLabel: getArcLabel,
          },
        ]}
        slotProps={{
          legend: {
            labelStyle: {
              fontSize: 14,
            },
            direction: 'column',
            position: {
              vertical: 'middle',
              horizontal: 'right',
            },
            itemMarkWidth: 20,
            itemMarkHeight: 20,
            markGap: 5,
            itemGap: 10,
          }
        }}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fill: 'white',
            fontSize: 14,
          },
        }}
        width={600}
        height={400}
      />


    </CardActions>
  );
}